import AdminSettingsProvider from './context/adminSettingsContext';
import RouteContainer from './RoutesContainer/RouteContainer';

function App() {
  return (
    <AdminSettingsProvider>
      <div className="App">
        <RouteContainer />
      </div>
    </AdminSettingsProvider>
  );
}

export default App;
